<template>
  <div class="hosOrder">
    <!-- <el-button class="btn_top" @click="open" type="primary">查看详情</el-button> -->
    <h3>订单详情<span @click="complain">投诉</span></h3>
    <div class="tail">
      <span>订单跟踪：</span>
      <div>
        <p v-if="createdTime1(otherList.orderStatus)"><span class="time">{{createdTime1(otherList.orderStatus)}}</span><span>{{orderStatus1(otherList.orderStatus)}}</span></p>
        <p v-if="createdTime2(otherList.orderStatus)"><span class="time">{{createdTime2(otherList.orderStatus)}}</span><span>{{orderStatus2(otherList.orderStatus)}}</span></p>
        <p v-if="createdTime3(otherList.orderStatus)"><span class="time">{{createdTime3(otherList.orderStatus)}}</span><span>{{orderStatus3(otherList.orderStatus)}}</span></p>
        <p v-if="createdTime4(otherList.orderStatus)"><span class="time">{{createdTime4(otherList.orderStatus)}}</span><span>{{orderStatus4(otherList.orderStatus)}}</span></p>
        <p v-if="createdTime5(otherList.orderStatus)"><span class="time">{{createdTime5(otherList.orderStatus)}}</span><span>{{orderStatus5(otherList.orderStatus)}}</span></p>
        <p v-if="createdTime6(otherList.orderStatus)"><span class="time">{{createdTime6(otherList.orderStatus)}}</span><span>{{orderStatus6(otherList.orderStatus)}}</span></p>
      </div>
    </div>
    <div class="info">
      <table>
        <tr>
          <td>代办时间</td>
          <td>{{otherList.getGoodsDate}}</td>
        </tr>
        <tr>
          <td>联系人姓名</td>
          <td>{{otherList.name}}</td>
        </tr>
        <tr>
          <td>联系人电话</td>
          <td>{{otherList.mobile}}</td>
        </tr>
        <tr>
          <td>服务信息</td>
          <td>{{otherList.serviceContent}}</td>
        </tr>
        <tr>
          <td>备注信息</td>
          <td>
            {{otherList.description}}
          </td>
        </tr>
       <tr>
         <td>代办备注</td>
         <td>
           {{otherList.commissionRemark}}
         </td>
       </tr>
        <tr>
          <td>追加备注</td>
          <td>{{ otherList.addRemark }}</td>
        </tr>
        <tr>
          <td>退回备注</td>
          <td>{{ otherList.refundRemark }}</td>
        </tr>
        <tr>
          <td>取消备注</td>
          <td>{{ otherList.cancelReason }}</td>
        </tr>

        <tr>
          <td>地址</td>
          <td>{{otherList.sendAddress}}</td>
        </tr>
        <tr>
          <td>应付酬劳</td>
          <td>￥{{otherList.payFee}}</td>
        </tr>
      </table>
    </div>


         <div class="info" v-if="otherList.isEvaluate == 1">
        <div class="info_title" style="font-size:30px;margin:30px 0px;">评价</div>
        <table>
          <tr>
            <td>评价内容</td>
            <td>{{ otherList.evaluateContent }}</td>
          </tr>
          <tr>
            <td>评价星级</td>
            <td>
              <el-rate
                v-model="otherList.evaluateStar"
                disabled
                show-score
                text-color="#ff9900"
              >
              </el-rate>
            </td>
          </tr>
          <tr>
            <td>评价时间</td>
            <td>{{ otherList.evaluateDate }}</td>
          </tr>
        </table>
      </div>
  </div>
</template>

<script>
import {reqOtherOrderDetail} from '../../../api'
export default {
  data() {
    return {
      otherList: {}
    }
  },
  created() {
    const {id} = this.$route.query
    reqOtherOrderDetail(id).then(res => {
      if(res.code === 200) {
        this.otherList = res.data.bussData
      }
    })
  },
  methods: {
    // 投诉
    complain() {
      const {id} = this.$route.query
      this.$router.push({name: 'Complain', query: {id}})
    },
    createdTime1(status) {
      return this.otherList.createDate
    },
    createdTime2(status) {
      return this.otherList.accessDate
    },
    createdTime3(status) {
      return this.otherList.paymentDate
    },
    createdTime4(status) {
      return this.otherList.evaluateDate
    },
    createdTime5(status) {
      return this.otherList.finishDate
    },
    createdTime6(status) {
      return this.otherList.cancelDate
    },
    orderStatus1 (status) {
      return '待支付'
    },
    orderStatus2 (status) {
      return '待抢单'
    },
    orderStatus3 (status) {
      return '进行中'
    },
    orderStatus4 (status) {
      return '待评价'
    },
    orderStatus5 (status) {
      return '已完成'
    },
    orderStatus6 (status) {
      return '已取消'
    },

  }
}
</script>

<style scoped lang="less" type="text/less">
.btn_top{
  margin-left: 50px;
}
.hosOrder{
  h3{
    font-size: 24px;
    margin-top:60px;
    span{
      margin-left: 59px;
      font-size: 16px;
      color:#2FA1DE;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .tail{
    margin-top:29px;
    display: flex;
    p{
      margin-bottom: 15px;
      .time{
        margin-right: 20px;
      }
    }
  }
  .hospital{
    padding-bottom: 30px;
    border-bottom:1px solid #e1e1e1;
    .hos{
      margin-top:27px;
      margin-bottom: 31px;
    }
  }
  .info{
    margin-top:30px;
    table{
      /*border:1px solid #e1e1e1;*/
      td{
        border:1px solid #e1e1e1;
        &:first-of-type{
          width: 129px;
          height: 40px;
          line-height: 40px;
          text-indent: 20px;
        }
        &:last-of-type{
          width: 440px;
          height: 40px;
          line-height: 40px;
          padding: 0 30px;
          box-sizing: border-box;
        }
      }
    }
    .orderDetail{
      width: 569px;
      box-sizing: border-box;
      margin-top:19px;
      padding:30px 30px 20px;
      border:4px solid #f1f1f1;
      div{
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        font-size: 16px;
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/OtherOrder.vue